module.exports = __webpack_public_path__ + "img/f5.88a083dd.png";